import { createAppContext, APP_CONTEXT_KEY } from '~/services/AppContext';

export default defineNuxtPlugin((nuxtApp) => {
    const appContext = createAppContext();
    nuxtApp.vueApp.provide(APP_CONTEXT_KEY, appContext);
});
